import React, { useState } from "react";
import "./HomeTestimonial.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const testimonials = [
  {
    img: "/images/girlimage.webp",
    text:
      "Mokosh Face Cream is a game-changer. Its lightweight formula hydrates deeply without any greasiness. My skin feels nourished and looks radiant. A pure delight for sensitive skin!",
    author: "Alex K.",
  },
  {
    img: "/images/girlimage2.webp",
    text:
      "I love Mokosh brand products, it absorbs quickly, for the day I use together with the cream, for the night only oil alone. I feel that the skin is very well moisturized and is not greasy. I recommend.",
    author: "Monika R.",
  },
  {
    img: "/images/girlimage3.webp",
    text:
      "Mokosh Face Cream is a skincare hero. It absorbs quickly, leaving my skin supple and glowing. A must for anyone craving a natural, effective moisturizer.",
    author: "Anna P.",
  },
];

function HomeTestimonial() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const maxSlide = testimonials.length - 1;

  const handleNext = () => {
    if (currentSlide < maxSlide) setCurrentSlide((prev) => prev + 1);
  };

  const handlePrev = () => {
    if (currentSlide > 0) setCurrentSlide((prev) => prev - 1);
  };

  return (
    <section className="home-testimonial">
      {/* LEFT ARROW: always visible if currentSlide > 0 */}
      {currentSlide > 0 && (
        <button className="arrow-btn-six arrow-left-six" onClick={handlePrev}>
          <FaChevronLeft />
        </button>
      )}

      {/* RIGHT ARROW: visible if not last slide */}
      {currentSlide < maxSlide && (
        <button className="arrow-btn-six arrow-right-six" onClick={handleNext}>
          <FaChevronRight />
        </button>
      )}

      {/* SLIDES */}
      <div
        className="testimonial-inner"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {testimonials.map((testimonial, index) => (
          <div className="testimonial-slide" key={index}>
            <div className="testimonial-avatar">
              <img src={testimonial.img} alt="User" />
            </div>

            <div className="testimonial-stars">
              {[...Array(5)].map((_, i) => (
                <span className="star" key={i}></span>
              ))}
            </div>

            <p className="testimonial-text">“{testimonial.text}”</p>
            <div className="testimonial-author">{testimonial.author}</div>
          </div>
        ))}
      </div>

      {/* DOTS */}
      <div className="testimonial-dots">
        {testimonials.map((_, index) => (
          <span
            key={index}
            className={currentSlide === index ? "active" : ""}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </section>
  );
}

export default HomeTestimonial;